import * as z from "zod/v4";
import { array, literal, number, object, string } from "zod/v4";
import { ContentType, TrackOrderUiState } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
} from "../message-parser-utils";
// TRACK ORDER
export const TrackOrderCustomerInputContentSchema = object({
  email: string(),
  orderId: string(),
});

export type TrackOrderCustomerInputContent = z.infer<
  typeof TrackOrderCustomerInputContentSchema
>;

export const TrackableFulfillmentSchema = array(
  object({
    orderCreatedAt: string().optional(),
    estimatedDeliveryDate: string().optional().nullable(),
    trackingDetails: array(
      object({ status: string(), datetime: string() }),
    ).optional(),
    trackingUrl: string().optional().nullable(),
    redoTrackingPageLink: string().optional(),
    carrier: string().optional().nullable(),
    trackingNumber: string().optional().nullable(),
    lineItems: array(
      object({
        productId: string(),
        productTitle: string(),
        variantId: string().optional().nullable(),
        variantTitle: string().optional().nullable(),
        url: string().optional().nullable(),
        price: object({ amount: number(), currencyCode: string() }),
        priceRange: object({
          minVariantPrice: object({ amount: number(), currencyCode: string() }),
          maxVariantPrice: object({ amount: number(), currencyCode: string() }),
        }).optional(),
        imageUrl: string().optional().nullable(),
        handle: string().optional().nullable(),
      }),
    ),
  }),
);

export type TrackableFulfillmentType = z.infer<
  typeof TrackableFulfillmentSchema
>;

const TrackOrderUiStructuredMessageSchema = z.discriminatedUnion("state", [
  object({ state: literal(TrackOrderUiState.ORDER_LOOKUP) }),
  object({
    state: literal(TrackOrderUiState.FOUND_ORDER),
    orderId: z.string(),
    email: z.string(),
    trackableFulfillmentsToDisplay: TrackableFulfillmentSchema,
  }),
]);

export const TrackOrderUiMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.TRACK_ORDER_UI),
  structuredContent: TrackOrderUiStructuredMessageSchema.optional(),
  customerInputContent: TrackOrderCustomerInputContentSchema.optional(),
});

export const TrackOrderUiMessageDbParser = TrackOrderUiMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);

export type TrackOrderUiMessageType = z.infer<
  typeof TrackOrderUiMessageDbParser
>;
